import(/* webpackMode: "eager" */ "/home/janab/freelance/alfamall/comverse-baseapp-next/app/(alfamall)/loading.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/janab/freelance/alfamall/comverse-baseapp-next/app/(alfamall)/pages/Homepage.jsx");
